import React from "react";
import {Image} from 'react-bootstrap';

import "./BackToTop.css";

import backtotop from "../../asset/images/backtotop.svg";

// 回到顶部
class BackToTop extends React.Component {
  constructor(pros) {
    super(pros)
    this.state = {show: "none"}
    this.onScroll = this.onScroll.bind(this);
    this.upTop = this.upTop.bind(this);
  }

  componentDidMount() {
    window.onscroll = this.onScroll;
  }

  upTop() {    
    requestAnimationFrame(function fn() {
      let t = document.documentElement.scrollTop;
      if(t > 0) {
        window.scrollTo(0, t-100);
        requestAnimationFrame(fn);
      }
    })
  }

  onScroll(){
    if (document.documentElement.scrollTop > 50) {
      this.setState({
        show: "block"
      })
    }else {
      this.setState({
        show: "none"
      })
    }
  }

  render() {
    return (
      <div className="backToTop">
        <Image type="button" style={{display: this.state.show}} onClick={this.upTop} src={backtotop} />
      </div>
    )
  }
}

export default BackToTop
